<template>
  <div v-element-visibility="[onElementVisibility, { scrollTarget: target }]">
    <div
      :class="{
        'easy-in-out duration-400 fixed bottom-0 left-0 right-0 z-10 mt-0 bg-white p-4 drop-shadow-[0_0px_5px_rgba(1,1,1,0.3)] transition-all md:static md:p-0 md:drop-shadow-none':
          !isVisible,
      }"
      class="duration-400 transition-all"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { vElementVisibility } from '@vueuse/components';
import { onMounted, ref, Ref } from 'vue';

const target: Ref<HTMLElement | null> = ref(null);
const isVisible: Ref<boolean> = ref(true);

function onElementVisibility(state: boolean) {
  if (target.value) {
    const elementTop = target.value.getBoundingClientRect()?.top;

    // If current sticky is not sticky enough, change check to '!=='
    if (window.screenY! > elementTop) {
      isVisible.value = state;
      return;
    }
  }

  isVisible.value = true;
}

onMounted(() => {
  target.value = document.getElementById('order-button');
  isVisible.value = true;
});
</script>
